export default __webpack_public_path__ + "static/media/restaurant_marker.3cc994cb.svg";